import { IApplicationState } from '../../types/redux';

export const selectShareCollection = (state: IApplicationState) => state.shareCollection;
